import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple} from '@fuse';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as Actions from '../../../auth/store/actions';
import {API} from "../../../config";
import {Button} from "@material-ui/core";
import {withContext} from "../../../yeffect/StateProvider";
import ContentDrawer from "../../../yeffect/drawerWrapper";
import OpenIsin from "./components/openIsin";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Util from "../../../yeffect/utils";
import {
  FilteringState,
  IntegratedFiltering, IntegratedPaging,
  IntegratedSorting,
  PagingState,
  SortingState, TableColumnResizing
} from "@devexpress/dx-react-grid";
import {Grid, PagingPanel,Table, TableFilterRow, TableHeaderRow} from "@devexpress/dx-react-grid-material-ui";

const m = require('moment-timezone');
const isinRecords = API.service('isin-records');

const styles = theme => ({
  layoutRoot: {},
});

class isinApplications extends Component {
  state = {
    isins: false,
    debug: true,
    drawerContent: false,
    drawerWidth:'80vw',
    spinner: false,
  };


  componentDidMount() {

    const controller = this;
    console.log(this.props)
    isinRecords.find({query:{$limit:20000}}).then(x => {
      controller.setState({
        isins: x.data
      })
    })
  }

  openDrawer = (isin) => {
    this.setState({
      drawerContent:(<OpenIsin isin={isin} isins={this.state.isins} closeDrawer={this.closeDrawer}/>),
      drawerWidth:'80vw',
    })
  }

  closeDrawer = () => {
    isinRecords.find({query:{$limit:20000}}).then(x => {
      this.setState({
        isins: x.data,
        drawerContent:false,
      })
    })
  }

  showSpinner = () => {
    this.setState({
      spinner:true,
    })
  }

  downloadTextFile = () => {
    var fileData = "";

    console.log(this.state.isins);
    console.log(this.state.isins[100]);

    this.state.isins.forEach(row=>{
      if (row.anna_status !== 'P' && row.anna_status !== 'E') {
        var textRow = row.isin + ";";
        textRow += row.anna_status + ";";
        textRow += row.application_type + ";";
        textRow += row.issuer_legal_description + ";";
        let cfi =  row.cfi_category + row.cfi_group + row.cfi_level1 + row.cfi_level2 + row.cfi_level3 + row.cfi_level4;
        textRow += ((cfi !== 0) ? cfi : "") + ";";
        textRow += ((row.fisn !== null) ? row.fisn : "")+ ";";
        textRow += ((row.issue_ipo === '0') ? 'N' : 'Y') + ";";
        textRow += ";";                    //Nominal Value
        textRow += ((row.issue_currency !== null) ? row.issue_currency : "")+ ";";
        textRow += ";";                    //Smallest Denomination
        textRow += ";";                    //Contract Size
        textRow += ((row.issue_maturity_date !== null) ? row.issue_maturity_date : "")+ ";";
        textRow += ";";                    //EXERCISE PRICE
        textRow += ";";                    //Exercise Price Currency
        textRow += ";";                    //Underlying
        textRow += ((row.issue_rate_type !== null) ?row.issue_rate_type : "") + ";";
        textRow += ((row.interest_rate !== null) ? row.interest_rate : "") + ";";
        textRow += ";";                    //Interest Payment Date
        textRow += ((row.issue_payment_frequency !== null) ? row.issue_payment_frequency : "")+ ";";
        textRow += ((row.issue_1st_coupon_date !== null) ? row.issue_1st_coupon_date : "")+ ";";
        textRow += ((row.isin_additional_info !== null) ? row.isin_additional_info : "CFI2015.") + ";";
        textRow += ";";                    //MIC
        textRow += ";";
        textRow += ((row.issuer_lei !== null) ? row.issuer_lei : "")+ ";";
        textRow += ";";                    //Fund Manager Name
        textRow += ((row.fund_manager_lei !== null) ? row.fund_manager_lei : "")+ ";";
        textRow += ";";                    //CSD
        textRow += row.issue_description + ";";
        textRow += ((row.lei !== null) ? row.lei : "")+ ";";
        textRow += ";";                    //Issuer Short Name
        textRow += "N;";                   //Supernational
        textRow += ((row.issuer_street_address_1 !== null) ? row.issuer_street_address_1 : "")+ ";";
        textRow += ((row.issuer_street_address_2 !== null) ? row.issuer_street_address_2 : "")+ ";";
        textRow += ((row.issuer_state !== null) ? row.issuer_state : "")+ ";";
        textRow += ((row.issuer_postcode !== null) ? row.issuer_postcode : "")+ ";";
        textRow += ((row.issuer_city !== null) ? row.issuer_city : "")+ ";";
        textRow += ((row.issuer_country !== null) ? row.issuer_country : "")+ ";";
        textRow += ((row.billing_street_address !== null) ? row.billing_street_address : "")+ ";";
        textRow += ((row.billing_street_address_2 !== null) ? row.billing_street_address_2 : "")+ ";";
        textRow += ((row.billing_state !== null) ? row.billing_state : "")+ ";";
        textRow += ((row.billing_postcode !== null) ? row.billing_postcode : "")+ ";";
        textRow += ((row.billing_city !== null) ? row.billing_city : "")+ ";";
        textRow += ((row.billing_country !== null) ? row.billing_country : "")+ ";";
        textRow += ";";                  //Old ISIN
        textRow += ";";                  //New ISIN
        textRow += ";";                  //Call/Put
        textRow += ";";                  //Underlying
        textRow += ((row.underlying_instrument !== null) ? row.underlying_instrument : "")+ ";";
        textRow += ((row.head_office_lei !== null) ? row.head_office_lei:"");
        textRow += "\n";

        fileData += textRow;
      }
    })

    const blob = new Blob([fileData], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.download = "CW-" + m().format('YYYY-MM-DD') + "-MASTER.txt";
    link.href = url;
    link.click();
  }

  render()
  {
    const {classes} = this.props;

    return (
        <FusePageSimple
            classes={{
              root: classes.layoutRoot
            }}
            header={
              <Toolbar className={'flex w-full'}>
                <div className={'flex-1 flex-grow'}>
                  <Typography variant="title" color="inherit">
                    <h3>ISIN Applications</h3>
                  </Typography>
                </div>
                {(this.state.isins !== false) &&
                <Button type="button"
                        variant="contained"
                        color="secondary"
                        className="mx-auto normal-case"
                        onClick={this.downloadTextFile}
                        value="firebase">{this.state.spinner &&
                <div className="spinner-wrapper">
                  <div className="spinner">
                    <div className="inner">
                      <div className="left">
                        <div className="half-circle"></div>
                      </div>
                      <div className="right">
                        <div className="half-circle"></div>
                      </div>
                    </div>
                  </div>
                </div>
                }
                  Download ASB File
                </Button>
                }
                &nbsp;&nbsp;
                <Button type="button"
                        variant="contained"
                        color="secondary"
                        className="mx-auto normal-case"
                        aria-label="LOGIN"
                        onClick={() => this.openDrawer({application_type: 'equity'})}
                        value="firebase">New Equity ISIN
                </Button>&nbsp;&nbsp;
                <Button type="button"
                        variant="contained"
                        color="secondary"
                        className="mx-auto normal-case"
                        aria-label="LOGIN"
                        onClick={() => this.openDrawer({application_type: 'debt'})}
                        value="firebase">New Debt ISIN
                </Button>
              </Toolbar>
            }
            content={
              <div className="p-12">
                {/*<Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>ISIN</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Issuer Details</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Domicile</TableCell>
                      <TableCell>Issuer Contact</TableCell>
                      <TableCell>Issuer Email</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(this.state.isins !== false) &&
                    <React.Fragment>
                      {(this.state.isins.map((isin)=>{
                        return (
                            <TableRow>
                              <TableCell>{isin.isin}</TableCell>
                              <TableCell style={{textTransform: 'capitalize'}}>{isin.application_type}</TableCell>
                              <TableCell>{isin.issuer_legal_description}</TableCell>
                              <TableCell>{isin.status}</TableCell>
                              <TableCell>{isin.issuer_country}</TableCell>
                              <TableCell>{isin.issuer_firstname} {isin.issuer_lastname}</TableCell>
                              <TableCell>{isin.issuer_email}</TableCell>
                              <TableCell><Button variant="outlined" color="primary" onClick={() => this.openDrawer(isin)}>View</Button></TableCell>
                            </TableRow>
                        )
                      }))}
                    </React.Fragment>
                    }
                  </TableBody>
                </Table>*/}
                {(this.state.isins !== false) &&
                <Grid
                    rows={this.state.isins}
                    columns={[
                      {name: 'isin', title: 'ISIN'},  
                      {name: 'application_type', title: 'Type', getCellValue: row => (Util.toTitleCase(row.application_type))},
                      {name: 'issue_description', title: 'Issuer Description', getCellValue: row => (Util.toTitleCase(row.issue_description))},
                      {name: 'anna_status', title: 'ANNA'},
                      {name: 'status', title: 'Status'},
                      {name: 'issuer_country', title: 'Country'},
                      {name: 'issuer_name', title: 'Name', getCellValue: row => (((Util.isEmpty(row.issuer_firstname)) ? '' : row.issuer_firstname) + " " +(Util.isEmpty(row.issuer_lastname) ? '' : row.issuer_lastname)) },
                      {name: 'issuer_email', title: 'Email'},
                      {name: 'createdAt', title: 'Submitted Date', getCellValue: row => m(row.createdAt).format('YYYY-MM-DD HH:mm:ss')},
                      {
                        name: 'Actions',
                        title: 'Actions',
                        getCellValue: row => (<Button variant="outlined" color="primary"
                                                      onClick={() => this.openDrawer(row)}>View</Button>)
                      },
                    ]}>
                  <SortingState
                      defaultSorting={[{columnName: 'createdAt', direction: 'desc'}]}
                  />
                  <IntegratedSorting/>
                  <FilteringState defaultFilters={[]}/>
                  <IntegratedFiltering/>
                  <PagingState
                      defaultCurrentPage={0}
                      defaultPageSize={20}
                  />
                  <IntegratedPaging/>
                  <Table/>
                  <TableColumnResizing defaultColumnWidths={this.state.columnWidths}/>
                  <TableHeaderRow showSortingControls/>
                  <TableFilterRow/>
                  <PagingPanel
                      pageSizes={this.state.pageSizes}
                  />
                </Grid>
                }
                {(this.state.drawerContent !== false) &&
                  <ContentDrawer drawerContent={this.state.drawerContent} drawerWidth={'80vw'} onClose={this.closeDrawer}/>
                }


                {(this.state.debug) &&
                    <div>
                      {this.props.context.drawerContent}
                    </div>
                }
              </div>
            }
        />
    )
  }
}

function mapDispatchToProps(dispatch)
{
  return bindActionCreators({
    setUserData: Actions.setUserData,
    setUserDataFromDB: Actions.setUserDataFromDB,
  }, dispatch);
}

function mapStateToProps({fuse, auth})
{
  return {
    login   : auth.login,
    user    : auth.user
  }
}

export default withContext(withStyles(styles, {withTheme: true})(connect(mapStateToProps,mapDispatchToProps)(isinApplications)));



// WEBPACK FOOTER //
// ./src/main/content/isinApplications/isinApplications.js